<template>
<div class="call-back-section">
    <h4 class="hf_heading04">Request to call back</h4>
    <form action="#">
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group hf_input-container">
              <label for="name">Name<span class="hf_primary">*</span></label>
              <input type="text" class="form-control hf_customInput" v-model="fullname" maxlength="100"	 placeholder="Enter your name">
              <p class="errorMessage" v-if="errors['fullname'] && errors['fullname'] !== ''">
				<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
				{{ errors["fullname"] }}
			  </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group hf_input-container">
				<label for="number">Mobile<span class="hf_primary">*</span></label>
				<div class="country-code-container">
					<span class="plus-code">+</span>
					<input type="number" id="cntCode" class="form-control hf_customInput conCode restricted-size" v-model="country_code" :maxlength = "maxCountryCodeLength">
					<input type="number" class="form-control hf_customInput mobile_number telNo " id="callBackMob" v-model="mobile_number" @keypress="isMobileNumber($event)" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" :maxLength = "maxMobileLength" placeholder="Enter your mobile number">
				</div>
				<p class="errorMessage" v-if="errors['mobile_number'] && errors['mobile_number'] !== ''">
					<span class="errorCircle" ><span class="errorSymbol">&#33;</span></span>
					{{ errors["mobile_number"] }}
				</p>
            </div>
          </div>
            
          <div class="col-sm-4">
            <div class="form-group hf_input-container">
              <label for="number">&nbsp;</label>
              <div class="button-container">
                <button type="button" :disabled="isFormSubmitting" class="btn-primaryRightIcon lg-primaryrightIcon" v-on:click="executeCaptcha()" >Call me back</button>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group captcha-div">
                <VueRecaptcha 
                sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
                ref="recaptchaModal"
                size="invisible"
                :load-recaptcha-script="true" 
                @verify="recaptchaVerifiedModal" 
                @expired="resetCaptchaModal">
            </VueRecaptcha>
            </div>
        </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { VueRecaptcha } from 'vue-recaptcha';
  import { watch } from '@vue/runtime-core';
  export default {
  	components: {
	    VueRecaptcha
	  },
    data() {
      return {
        fullname: "",
        email_address: "",
        country_code: "91",
        mobile_number: "",
        maxCountryCodeLength: 3,
        maxMobileLength: 10,
        recaptchaToken:'',
        isFormSubmitting: false,
        errors: []
      };
    },
    watch: {
      fullname(userName) {
        this.fullname = userName;
        this.errors["fullname"] = '';
        if( this.fullname !== '' && !this.validateCharacters(this.fullname) ) // Check is valid entered name
          this.errors["fullname"] = "Please enter valid Name.";
      },
      country_code(countryCode) {
        this.country_code = $.trim(countryCode);
        if (countryCode.toString().length > this.maxCountryCodeLength) {
          this.country_code = $.trim(countryCode.toString().slice(0, this.maxCountryCodeLength));
        }
        if (this.country_code.toString().length > 0 && this.country_code.toString().length <= this.maxCountryCodeLength ){
          this.errors["mobile_number"] = '';
          if( this.country_code == 91 ) {
              this.maxMobileLength = 10;
              if( this.mobile_number.toString().length > 0 ) {
                if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
                  this.errors["mobile_number"] = "Please enter valid Mobile Number.";
              }
          }
          else{
            this.maxMobileLength = 13;
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            if( this.mobile_number.toString().length > 0 ) {
              if( !this.validateInternationalMobileNumber(this.mobile_number) )
                this.errors["mobile_number"] = "Please enter valid Mobile Number.";
            }
          }
        }
        else
          this.errors["mobile_number"] = "Please enter valid Country Code";
      },
      mobile_number(mobileNumber){
        this.mobile_number = $.trim(mobileNumber);
        if( mobileNumber.toString().length > this.maxMobileLength ){
          this.mobile_number = $.trim(mobileNumber.toString().slice(0, this.maxMobileLength));
        }
        if( this.mobile_number.toString().length > 0 && this.country_code.toString().length > 0 ) {
          if( this.country_code == 91 ) {
            this.errors["mobile_number"] = '';
            if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
          else {
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            this.errors['mobile_number'] = '';
            if( !this.validateInternationalMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
        }
      },
    },
    methods: {
    	resetCaptchaModal() {
	      this.$refs.recaptchaModal.reset();
	      this.recaptchaToken = "";
	    },
	    recaptchaVerifiedModal(token) {
	      if (token ){
            this.recaptchaToken = token;
            this.validatePartnerDataForm();
          }
	    },
      async isMobileNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      executeCaptcha(){
        this.$refs.recaptchaModal.execute();
      },
      async validatePartnerDataForm(){
		this.isFormSubmitting = true;
        var fullName = $.trim(this.fullname);
        var countryCode = $.trim(this.country_code);
        var mobileNumber = $.trim(this.mobile_number);
        // // LET'S VALIDATE FINAL FORM
        if(this.validateCharacters(fullName) && countryCode.toString().length > 0 && ((countryCode == '91' && this.validateMobileNumber(mobileNumber)) || (countryCode !== '91' && this.validateInternationalMobileNumber(mobileNumber))) ){
            var emailIdArr = [];
            var partnerName = $('#partnerName').val();
            // emailIdArr.push(partnerEmail);
            emailIdArr.push($('#partnerEmail').val());

      var isPartner = $("#isPartner").val();
			// API data
			let userdata = {
				recaptcha_token: this.recaptchaToken,
				fullname: fullName,
				country_code: countryCode,
				mobile_number: mobileNumber,
        isPartner: isPartner,
        emailIdArr:emailIdArr
			}
			axios.post('/callPartnerNotification', userdata).then((apiResponse) => {
                var responseData = apiResponse.data;
				this.isFormSubmitting = false;
				console.log(responseData);
				if( responseData.status == 1 ){
                    this.fullname="";
                    this.country_code="91";
                    this.mobile_number="";
                    this.errors = [];
                    alertBox("Success", 'Thank You. '+partnerName+' has been informed and will connect with you in some time.', "success");
                    this.$refs.recaptchaModal.reset();
				}else{
					console.log(responseData.res);
                    this.$refs.recaptchaModal.reset();
				}
			}).catch(response => {
				this.isFormSubmitting = false;
				console.log(response.data);
                this.$refs.recaptchaModal.reset();
			});
        }
        else {
			this.isFormSubmitting = false;
            this.$refs.recaptchaModal.reset();
          if (!this.validateCharacters(fullName))
            this.errors["fullname"] = "Please enter valid Name.";
          
          if( (countryCode == '91' && !this.validateMobileNumber(mobileNumber)) ||
            (countryCode !== '91' && !this.validateInternationalMobileNumber(mobileNumber)) )
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }  // endif form validation
      },
    },
    mounted(){
      
    }
  };
  </script>
  
